import request from '@/utils/request';
import qs from 'qs'

// 识物英语
export function recognizeChat(data) {
    return request({
        url: '/chat/recognize',
        method: 'post',
        data
    })
}

// 文字搜图
export function txtSearch(params) {
    return request({
        url: '/text2image',
        method: 'get',
        params
    })
}


// 行政区列表
export function areasBasic(params) {
    return request({
        url: '/basic/areas',
        method: 'get',
        params
    })
}


// 学段列表
export function stagesBasic(params) {
    return request({
        url: '/basic/stages',
        method: 'get',
        params
    })
}
// 年级列表
export function gradesBasic(params) {
    return request({
        url: '/basic/grades',
        method: 'get',
        params
    })
}
// 学科列表
export function subjectsBasic(params) {
    return request({
        url: '/basic/subjects',
        method: 'get',
        params
    })
}














// 试题分类列表
export function tagsBasic(params) {
    return request({
        url: '/basic/tags',
        method: 'get',
        params
    })
}
// 试题难度列表
export function difficultiesBasic(params) {
    return request({
        url: '/basic/question/difficulties',
        method: 'get',
        params
    })
}
// 试题题型列表
export function typesBasic(params) {
    return request({
        url: '/basic/question/types',
        method: 'get',
        params
    })
}
// 教材版本列表
export function versionsBasic(params) {
    return request({
        url: '/basic/textbook/versions',
        method: 'get',
        params
    })
}
// 教材列表
export function textbooksBasic(params) {
    return request({
        url: '/basic/textbooks',
        method: 'get',
        params
    })
}
// 教材章节列表
export function catalogsBasic(params) {
    return request({
        url: '/basic/textbook/catalogs',
        method: 'get',
        params
    })
}
// 教材章节知识点列表
export function knowledge_pointsBasic(params) {
    return request({
        url: '/basic/textbook/catalog/knowledge-points',
        method: 'get',
        params
    })
}

// 教材章节知识点树形结构
export function treeBasic(params) {
    return request({
        url: '/basic/textbook/tree',
        method: 'get',
        params
    })
}




// 获取个人信息
export function infoProfile(params) {
    return request({
        url: '/user/profile/info',
        method: 'get',
        params
    })
}
// 编辑个人信息
export function editProfile(data) {
    return request({
        url: '/user/profile/edit',
        method: 'post',
        data
    })
}

// 编辑个人信息
// export function editProfile(data) {
//     return request({
//         url: '/user/profile/edit',
//         method: 'post',
//         data
//     })
// }
// 登录
export function loginProfile(data) {
    return request({
        url: '/user/login',
        method: 'post',
        data
    })
}
// 发送短信验证码
export function sendCode(data) {
    return request({
        url: '/user/sendCode',
        method: 'post',
        data
    })
}
